/*import tim from '../../tim.js'
import TIM from 'tim-js-sdk/tim-js-friendship'*/
import {agreeSendResume, applyResume, netTalkPerson, refuseSendResume, sendResumeChat} from '@/api/person'
import { Toast } from 'vant'
import {chatNetRecommendJobs} from '@/api/person'
import {isEmpty} from '@/utils/common';
const person = {
    namespaced: true,
    state: {
        recommendJobs:[],
    },
    getters: {

    },
    mutations: {
        setRecommendResumes(state, data) {
            state.recommendResumes = [...state.recommendResumes, data]
        },
    },
    actions:{
        sendResumeChat(context,param) {
            sendResumeChat(param.userId,param.toUserId,param.resumeId).then(res => {
                if (res.status===200) {
                    Toast('发送成功')
                }else{
                    Toast.fail(res.message)
                }
            })
        },
        chatNetRecommendJobs(context,param) {
            return new Promise((resolve) => {
                chatNetRecommendJobs(param.jobfair_id,param.limit,param.page).then(res => {
                    if (res.status===200) {
                        context.state.recommendJobs=res.data.data.recommendJobs
                    }else{
                        Toast.fail('获取推荐求职者失败！')
                        context.state.recommendJobs={}
                    }
                    resolve()
                })
            })
        },
        agreeSendResume(context,param){
            agreeSendResume(param.userId,param.toUserId,param.resumeId,param.msgId,).then(res => {
                if (res.status===200) {
                    Toast('回复成功！')
                }else{
                    Toast.fail(res.message)
                }
            })
        },
        refuseSendResume(context,param){
            refuseSendResume(param.userId,param.toUserId,param.msgId,).then(res => {
                if (res.status===200) {
                    Toast('回复成功！')
                }else{
                    Toast.fail(res.message)
                }
            })
        },
        //个人洽谈企业
        async netTalkPerson(context,param){
            const res = await netTalkPerson(param.jobId,param.jobfair_id)
            return res
        },
        applyResume(context,param){
            return new Promise((resolve,reject) => {
                applyResume(param.jobId,param.resumeId,param.is_temp).then(res => {
                    if (res.message==='OK') {
                        Toast('投递成功！')
                    }else{
                        Toast.fail(res.message)
                    }
                    resolve()
                }).catch(function (err) {
                    if (isEmpty(err.message)){
                        Toast.fail(err.response.data.message)
                        return ;
                    }
                    if (err.message==='OK'){
                        Toast('投递成功！')
                        return;
                    }
                    Toast.fail(err.message)
                    reject(err);
                })
            })
        },
    },
}

export default person
